import { KeyboardEvent } from 'react'

type GridKeyboardShortcuts<TShortcut> = {
    disabled: boolean
    onDelete?: () => void
    onCopy?: () => void
    onCut?: () => void
    onPaste?: () => void
    getShortcut?: (event: KeyboardEvent<HTMLDivElement>) => TShortcut | null | undefined
    onToggle?: (shortcut: NoInfer<TShortcut>) => void
}

/** Keeps shortcut routing local to focused grid cells; consumers own selection and actions. */
export function createGridKeyboardHandler<TShortcut>({ disabled, onDelete, onCopy, onCut, onPaste, getShortcut, onToggle }: GridKeyboardShortcuts<TShortcut>) {
    return (event: KeyboardEvent<HTMLDivElement>) => {
        if (disabled || !(event.target instanceof Element) || !event.target.matches('[data-cell]')) return

        const isMetaKeyPressed = event.metaKey || event.ctrlKey
        let action: (() => void) | undefined

        if (event.code === 'Backspace' || event.code === 'Delete') {
            action = onDelete
        } else if (isMetaKeyPressed && event.code === 'KeyC') {
            action = onCopy
        } else if (isMetaKeyPressed && event.code === 'KeyX') {
            action = onCut
        } else if (isMetaKeyPressed && event.code === 'KeyV') {
            action = onPaste
        }

        if (action) {
            event.preventDefault()
            action()
            return
        }

        const shortcut = getShortcut?.(event)
        if (shortcut === null || shortcut === undefined || !onToggle) return

        event.preventDefault()
        onToggle(shortcut)
    }
}
